export function deepCopy(array) {
  return JSON.parse(JSON.stringify(array));
}

// Shuffle array in-place
export function shuffleArray(array) {
  for (let i = array.length - 1; i > 0; i--) {
    const j = Math.floor(Math.random() * (i + 1));
    [array[i], array[j]] = [array[j], array[i]];
  }
}


